<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div>
      <base-button type="primary" @click.prevent="onNew" icon>
        <span class="btn-inner--icon">
          <i class="ni e-add"></i>
        </span>New record
      </base-button>
      <base-button type="info" @click.prevent="onRefresh" icon>
        <span class="btn-inner--icon">
          <i class="ni refresh-02"></i>
        </span>Refresh
      </base-button>
    </div>
    <el-table :data="tableData" row-key="id" header-row-class-name="thead-light">
      <el-table-column label="Pay date" prop="paydate"></el-table-column>
      <el-table-column label="Amount" prop="amount"></el-table-column>
      <el-table-column min-width="120px" align="right" label="Actions">
        <div slot-scope="{row}" class="d-flex">
          <base-button @click.native="onEdit(row)" class="edit" type="warning" size="sm" icon>
            <i class="text-white ni n-edit"></i>
          </base-button>
          <base-button
            @click.native="onDelete(row)"
            class="remove btn-link"
            type="danger"
            size="sm"
            icon
          >
            <i class="text-white ni e-remove"></i>
          </base-button>
        </div>
      </el-table-column>
    </el-table>

    <modal :show.sync="modalform" size="sm">
      <h6 slot="header" class="modal-title">Installment action</h6>
      <validation-observer ref="formvalid">
        <div class="row">
          <div class="col-lg-12">
            <base-input label="Pay date" rules="required" name="Pay date">
              <flat-picker
                :config="{allowInput: true, minDate: mindt, maxDate: maxdt}"
                class="form-control datepicker"
                v-model="inst.paydate"
              ></flat-picker>
            </base-input>
          </div>
          <div class="col-lg-12">
            <base-input
              type="number"
              label="Amount"
              placeholder="Amount"
              v-model="inst.amount"
              name="amount"
              rules="required"
            ></base-input>
          </div>
        </div>
      </validation-observer>
      <div class="text-center">
        <base-button type="success" @click.native="onSave()">Save changes</base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import { Table, TableColumn, Select, Option, Tabs, TabPane } from "element-ui";
import { Modal, BaseAlert } from "@/components";
import { InstallmentType } from "../../../services/types";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  GetInstallments,
  DeleteInstallment,
  CreateInstallment,
  UpdateInstallment,
} from "../../../services/payments";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "installments",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    Modal,
    Loading,
    flatPicker,
  },
  props: {
    paymentId: String,
    mindt: String,
    maxdt: String,
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      modalform: false,
      inst: {},
      pid: this.paymentId,
    };
  },
  methods: {
    loadInsts() {
      if (!this.paymentId) return;
      this.isLoading = true;

      GetInstallments(this.paymentId).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onNew() {
      this.inst = new InstallmentType();
      this.inst.paymentid = this.paymentId;
      this.modalform = true;
    },
    onEdit(row) {
      this.inst = Object.assign({}, row);
      this.modalform = true;
    },
    onSave(status) {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (!this.inst.id) {
            CreateInstallment(this.inst).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.notifyVue("success");

                this.loadInsts();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdateInstallment(this.inst).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.loadInsts();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    onRefresh() {
      this.loadInsts();
    },
    onDelete(row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            DeleteInstallment(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.loadInsts();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
  },
  mounted() {
    this.loadInsts();
  },
};
</script>

<style lang="scss" scoped>
</style>